import React from 'react';
import { Link } from 'react-router-dom';

export default function TrustWealthLogo() {
  return (
    <Link to="/" className="flex items-center">
      <img
        src="/twealth.png"
        alt="Willowvale Credit Union"
        className="h-14 md:h-16 lg:h-20 w-auto max-w-[320px] transition-all duration-300 dark:invert dark:opacity-95"
      />
    </Link>
  );
}
